<!-- @format -->
<script lang="ts">
  import type { Rel, Tag, Type, Target } from "~/components/fragment-sets/basic_component/Button.svelte";

  type Cutout = "bottom-right" | "top-right" | "top-left" | "bottom-left";

  let _class = "";
  export { _class as class };

  export let href: string = '';
  export let target: Target | undefined = undefined;

  export let type: Type = "primary";
  export let cutout: Cutout = "bottom-right";
  export let invert = false;

  export let tag: Tag = "a";
  export let disabled = false;

  export let rel: Rel | undefined = target ? 'noopener' : undefined;

</script>

{#if tag == 'a'}
  <a class="btn btn-{type} btn-cut-{cutout} text-break {_class}" class:invert on:click
    {href} {target} {rel}>
    <span><slot /></span>
  </a>
{:else if tag == 'button'}
  <button class="btn btn-{type} btn-cut-{cutout} text-break {_class}" class:invert
    on:click {disabled}>
    <span><slot /></span>
  </button>
{/if}


<style lang="scss">
  .btn {
    position: relative;
    display: inline-block;
    padding: 0.625rem 1rem;
    color: var(--text-color);
    background-color: transparent;
    border: none;
    border-radius: 0;
    font-weight: 400;
  }

  .invert {
    filter: invert(100%);
  }

  .btn span {
    position: relative;
    transition: color 50ms;
  }

  .btn-primary.outer-wrapper:hover {
    background-color: var(--color-black);
  }

  .btn-primary {
    --btn-color: var(--color-black);
    --stroke-color: var(--color-black);
    --text-color: var(--color-white);
  }

  .btn-primary:hover {
    --btn-color: var(--color-white);
    --text-color: var(--color-black);
  }

  .btn-secondary {
    --btn-color: transparent;
    --stroke-color: var(--color-black);
    --text-color: var(--color-black);
  }
  .btn-secondary:hover {
    --btn-color: var(--color-black);
    --stroke-color: var(--color-black);
    --text-color: var(--color-white);
    
  }

  .btn::before,
  .btn::after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transition: background-color 50ms;
  }
  
  .btn::before {
    background-color: var(--btn-color);
    clip-path: polygon(var(--clip));
  }

  .btn::after {
    background-color: var(--stroke-color);
    clip-path: polygon(var(--clip), var(--clip-reverse));
  }

  .btn-cut-bottom-right {
    --clip: 0 0, 100% 0, 100% calc(100% - 16px), calc(100% - 16px) 100%, 0 100%, 0 0; 
    --clip-reverse: 1px 1px, 1px calc(100% - 1px), calc(100% - 16.5px) calc(100% - 1px), 
      calc(100% - 1px) calc(100% - 16.5px), calc(100% - 1px) 1px, 1px 1px;
  }

  .btn-cut-top-right {
    --clip: 0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%, 0 0;
    --clip-reverse: 1px 1px, 1px calc(100% - 1px), calc(100% - 1px) calc(100% - 1px), 
      calc(100% - 1px) 16.5px, calc(100% - 16.5px) 1px, 1px 1px;
  }

  .btn-cut-top-left {
    --clip: 16px 0, 100% 0, 100% 100%, 0 100%, 0 16px, 16px 0;
    --clip-reverse: 16.5px 1px, 1px 16.5px, 1px calc(100% - 1px),
      calc(100% - 1px) calc(100% - 1px), calc(100% - 1px) 1px, 16.5px 1px;
  }

  .btn-cut-bottom-left {
    --clip: 0 0, 100% 0, 100% 100%, 16px 100%, 0 calc(100% - 16px), 0 0;
    --clip-reverse: 1px 1px, 1px calc(100% - 16.5px), 16.5px calc(100% - 1px),
      calc(100% - 1px) calc(100% - 1px), calc(100% - 1px) 1px, 1px 1px;
  }
</style>
